/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const streetPageEspotsSX: SxProps = {

	marginTop:'30px;',
};

export const streetPageEspotChildSX: SxProps = {

	marginTop:'15px',
	'& ': {
		bgcolor:'#fad901',
	}, 
	
}

export const streetPageStoreClosedColorSX: SxProps = {
	color:'#ff914d;',
}
export const streetPageBackToWinkelSX: SxProps = {
	color:"#69baf8",
	fontWeight:700,
	marginBottom:'30px;',
	cursor: 'pointer'
}
export const streetPageStoreBejijkButtonSX: SxProps = {
	display:'flex',
	justifyContent:'center',
	'& button':{
		maxHeight:'25px',
		maxWidth:'155px',
		border:1, 
		fontFamily: 'mikado-regular,Effra, Helvetica, sans-serif',
	}
}
